var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommercialBuyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7562,
    cy: 13.4064,
    r: 12.5,
    fill: "#001E3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3396 18.073V7.573H12.1729V9.90633H18.0063V14.573H16.8396V11.073H12.1729V12.2397H13.3396V13.4063H12.1729V14.573H13.3396V15.7397H12.1729V16.9063H14.5063V18.073H6.3396ZM7.50627 16.9063H8.67293V15.7397H7.50627V16.9063ZM7.50627 14.573H8.67293V13.4063H7.50627V14.573ZM7.50627 12.2397H8.67293V11.073H7.50627V12.2397ZM7.50627 9.90633H8.67293V8.73966H7.50627V9.90633ZM9.8396 16.9063H11.0063V15.7397H9.8396V16.9063ZM9.8396 14.573H11.0063V13.4063H9.8396V14.573ZM9.8396 12.2397H11.0063V11.073H9.8396V12.2397ZM9.8396 9.90633H11.0063V8.73966H9.8396V9.90633ZM16.8396 19.2397V18.073H15.6729V16.9063H16.8396V15.7397H18.0063V16.9063H19.1729V18.073H18.0063V19.2397H16.8396ZM14.5063 13.4063V12.2397H15.6729V13.4063H14.5063ZM14.5063 15.7397V14.573H15.6729V15.7397H14.5063Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialBuyer);
export default __webpack_public_path__ + "static/media/commercial_buyer.832fb37a1bb87c6b84bd9daddf246008.svg";
export { ForwardRef as ReactComponent };